import { BaseMole } from "../BaseMole";
import { MoleAnimationController, MoleAnimationState } from "../MoleAnimationController";
import { IMoleState } from "./IMoleState";

export class DieState implements IMoleState {
    private nextState: IMoleState;

    public constructor(
        private readonly mole: BaseMole,
        private readonly animationController: MoleAnimationController,
    ) {
        this.nextState = this;
    }

    public enter(_previousState: IMoleState): void {
        this.animationController.onClipEnd.add(this.handleClipEnd, this);
        this.animationController.transitToState(MoleAnimationState.Death);
    }

    private handleClipEnd(_state: MoleAnimationState): void {
        this.nextState = null;
    }

    public exit(): void {
        this.animationController.onClipEnd.remove(this.handleClipEnd, this);
    }

    public process(_dt: number): IMoleState {
        return this.nextState;
    }

}